import "can/model/";
var pageCount = 0;

function setPageCount ( data ) {
    pageCount = data;
}

function getPageCount ( ) {
    return pageCount;
}

export default can.Model.extend({
    findAll: function( params ) {
        "use strict";
        return can.ajax({
            url: "/api/v2/visibilitySets?" + can.param( params ),
            type: "GET",
            dataType: "json"
        });
    },

    parseModels: function( data, xhr ) {
        "use strict";
        var pageCount = xhr.getResponseHeader("X-Total-Count");

        setPageCount(pageCount);

        return data;
    },

    create: function (params) {
        "use strict";

        return can.ajax({
            url: "/api/v2/visibilitySets",
            type: "POST",
            data: JSON.stringify(params.visibilitySets),
            contentType: "application/json",
            dataType: "JSON"
        });
    },

    update: function (id, params) {
        "use strict";

        return can.ajax({
            url: "/api/v2/visibilitySets",
            type: "PUT",
            data: JSON.stringify(params.visibilitySets),
            contentType: "application/json",
            dataType: "JSON"
        });
    },

    destroy: function( id ) {
        "use strict";
        return can.ajax({
            url: "/api/v2/visibilitySets/" + id,
            type: "DELETE"
        });
    },

    getPageCount : function ( ) {
        return getPageCount();
    }

}, {});